import { createSlice } from '@reduxjs/toolkit'
const userStore = createSlice({
	name: 'user',
	initialState: {
		isOpen: false,
		isChartOpen: false,
		userInfo: {
			token: localStorage.getItem('token') || "",
			username: localStorage.getItem('username') || "",
			refreshToken: localStorage.getItem('refreshToken') || "",
			email: localStorage.getItem('email') || "",
			roleId: localStorage.getItem('roleId') || "",
			password: localStorage.getItem('password') || "",
			nickname: localStorage.getItem('nickname') || "",
			uuid: localStorage.getItem('uuid') || "",
		},
		// collections:[],
		avatar: localStorage.getItem('avatar') || "",
	},
	reducers: {
		setIsOpen(state, action) {
			state.isOpen = action.payload
		},
		// setCollections(state, action) {
		// 	state.collections = action.payload
		// 	console.log(action.payload)
		// 	localStorage.setItem('collections',action.payload)
		// },
		setIsChartOpen(state, action) {
			state.isChartOpen = action.payload
		},
		setUserInfo(state, action) {
			 // 直接修改对象属性
			 Object.keys(action.payload).forEach(key => {
                state.userInfo[key] = action.payload[key];
				localStorage.setItem(key, state.userInfo[key])
            });
			window.dispatchEvent(new Event("setRoleId")); // 触发路由更新
			
		},
		setAvatar(state, action) {
			state.avatar = action.payload
			localStorage.setItem('avatar', action.payload)
		},
	},
})
export const { setIsOpen, setUserInfo, setAvatar, setIsChartOpen } = userStore.actions
export default userStore.reducer
